// Markdown string rendered with `Body` typography; skipHtml blocks pasted HTML from injecting markup.
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { bodyVariants } from "./Body";
import "./Typography.css";

export interface MarkdownBodyProps {
  /** The markdown string to render */
  children: string;
  /** The size variant of the body text @default "md" */
  size?: "lg" | "md" | "sm" | "xs" | "xxs";
  /** Additional CSS classes applied to the wrapper */
  className?: string;
}

export const MarkdownBody = ({
  children,
  size = "md",
  className,
}: MarkdownBodyProps) => {
  const bodyClass = bodyVariants({ size });
  const combinedClassName = className ? `${bodyClass} ${className}` : bodyClass;

  return (
    <div className={combinedClassName}>
      <ReactMarkdown
        skipHtml={true}
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ ...props }) => <p className="mb-2 last:mb-0" {...props} />,
          strong: ({ ...props }) => (
            <strong className="font-semibold" {...props} />
          ),
          em: ({ ...props }) => <em className="italic" {...props} />,
          ul: ({ ...props }) => (
            <ul className="list-disc list-outside pl-5 mb-2" {...props} />
          ),
          ol: ({ ...props }) => (
            <ol className="list-decimal list-outside pl-5 mb-2" {...props} />
          ),
          li: ({ ...props }) => <li className="mb-1 last:mb-0" {...props} />,
          a: ({ ...props }) => (
            <a
              className="text-indigo-text-link hover:text-indigo-text-link-hover underline"
              target="_blank"
              rel="noopener noreferrer"
              {...props}
            />
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
};

MarkdownBody.displayName = "MarkdownBody";
